import { GarageAttachment } from "./GarageAttachment";
import { Sign } from "./Sign";

export class Garage {
    public id: string;
    public codiceFl: string;
    public codiceDirette: string;
    public piva: string;
    public cf: string;
    public rascl: string;
    public concConso: string;
    public indirizzo: string;
    public localita: string;
    public cap: string;
    public provincia: string;
    public nazione: string;
    public telefono: string;
    public fax: string;
    public cellulare: string;
    public email: string;
    public tipologia: string;
    public note: string;
    public altraInsegna: string;
    public riferimento: string;
    public flagBo: boolean;
    public incaricato: string;
    public cfl: string;
    public attachments:Array<GarageAttachment>;
    public signs:Array<Sign>;
}